import { all } from 'redux-saga/effects';
import profile from './profile';
import dashboard from './dashboard';
import transactions from './transactions';
import payments from './payments';
import anticipations from './anticipations';
import bankAccounts from './bank-accounts';
import rates from './rates';
import banks from './banks';
import compensationStrategies from './compensation-strategies';
import integrations from './integrations';
import customers from './customers';
import products from './products';
import invoices from './invoices';
import developer from './developer';
import antifraud from './antifraud';
import users from './users';
import machines from './machines';

export default function* rootSaga() {
  yield all([
    ...profile,
    ...dashboard,
    ...transactions,
    ...payments,
    ...anticipations,
    ...bankAccounts,
    ...rates,
    ...banks,
    ...compensationStrategies,
    ...integrations,
    ...customers,
    ...products,
    ...invoices,
    ...developer,
    ...antifraud,
    ...users,
    ...machines
  ]);
}
